module.exports = __webpack_public_path__ + "static/media/29ADMSPC36.feb851d7.jpg";